import { AddMmseReport } from "app/screens/residents/show/AddMmseReport";

export default function AddMmseReportPage() {
  return <AddMmseReport />;
}
